export default __webpack_public_path__ + "static/media/Summoner's Robes of the Emperor's Favor.c38aa445.jpg";